module.exports = __webpack_public_path__ + "img/2.54590a53.png";